<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>company.connectivity.details.equipment.info-popup.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <div *ngIf="!loading" class="main">
        <div class="equipment-info">
          <table class="equipment-info__table">
            <tbody>
              <tr *ngIf="equipmentInfoDetails?.equipment_catalog_entry?.links">
                <td class="label" translate>company.connectivity.details.equipment.info-popup.table.brand.label</td>
                <td>
                  <span *ngIf="equipmentInfoDetails?.equipment_catalog_entry?.brand">
                    {{equipmentInfoDetails.equipment_catalog_entry.brand}}
                  </span>
                  <span *ngIf="!equipmentInfoDetails?.equipment_catalog_entry?.brand"> - </span>
                </td>
              </tr>
              <tr *ngIf="equipmentInfoDetails?.equipment_catalog_entry?.links">
                <td class="label" translate>company.connectivity.details.equipment.info-popup.table.name.label</td>
                <td>
                  <span *ngIf="equipmentInfoDetails?.equipment_catalog_entry?.model">
                    {{equipmentInfoDetails.equipment_catalog_entry.model}}
                  </span>
                  <span *ngIf="!equipmentInfoDetails?.equipment_catalog_entry?.model"> - </span>
                </td>
              </tr>
              <tr *ngIf="equipmentInfoDetails?.equipment_type">
                <td class="label" translate>company.connectivity.details.equipment.info-popup.table.type.label</td>
                <td>
                  <gdp-connectivity-entry-type [type]="equipmentInfoDetails.equipment_type">
                  </gdp-connectivity-entry-type>
                </td>
              </tr>
              <tr *ngIf="equipmentInfoDetails?.equipment_catalog_entry?.links">
                <td class="label" translate>company.connectivity.details.equipment.info-popup.table.documents.label</td>
                <td>
                  <a *ngFor="let link of equipmentInfoDetails?.equipment_catalog_entry?.links" [href]="link.url"
                    target="_blank">{{link.name}}</a>
                </td>
              </tr>
              <tr>
                <td class="label" translate>company.connectivity.details.equipment.info-popup.table.status.label</td>
                <td>
                  <div class="data">
                    <span><b translate>company.connectivity.details.equipment.info-popup.table.status.status</b></span>
                    <span
                      *ngIf="equipmentInfoDetails?.wifi?.connection_status">{{equipmentInfoDetails.wifi.connection_status}}</span>
                    <span *ngIf="!equipmentInfoDetails?.wifi?.connection_status"> - </span>
                  </div>
                  <div class="data">
                    <span><b
                        translate>company.connectivity.details.equipment.info-popup.table.status.description</b></span>
                    <span
                      *ngIf="equipmentInfoDetails?.wifi?.connection_status_description">{{equipmentInfoDetails.wifi.connection_status_description}}</span>
                    <span *ngIf="!equipmentInfoDetails?.wifi?.connection_status_description"> - </span>
                  </div>
                <td>
              </tr>
              <tr>
                <td class="label" translate>company.connectivity.details.equipment.info-popup.table.provider.label</td>
                <td>
                  <span
                    *ngIf="equipmentInfoDetails?.wifi?.provider_name">{{equipmentInfoDetails.wifi.provider_name}}</span>
                  <span *ngIf="!equipmentInfoDetails?.wifi?.provider_name"> - </span>
                <td>
              </tr>
              <tr *ngIf="equipmentInfoDetails?.wifi?.ping">
                <td class="label" translate>company.connectivity.details.equipment.info-popup.table.ping.label</td>
                <td>
                  <span>{{equipmentInfoDetails.wifi.ping}}</span>
                </td>
              </tr>
              <tr>
                <td class="label" translate>company.connectivity.details.equipment.info-popup.table.technology.label
                </td>
                <td>
                  <span *ngIf="equipmentInfoDetails?.wifi?.technology">{{equipmentInfoDetails.wifi.technology}}</span>
                  <span *ngIf="!equipmentInfoDetails?.wifi?.technology"> - </span>
                </td>
              </tr>
              <tr>
                <td class="label" translate>company.connectivity.details.equipment.info-popup.table.product.label</td>
                <td>
                  <span *ngIf="equipmentInfoDetails?.wifi?.product">{{equipmentInfoDetails.wifi.product}}</span>
                  <span *ngIf="!equipmentInfoDetails?.wifi?.product"> - </span>
                </td>
              </tr>
              <tr>
                <td class="label" translate>company.connectivity.details.equipment.info-popup.table.4g.label</td>
                <td>
                  <span
                    *ngIf="[true, false].includes(equipmentInfoDetails?.wifi?.has_4g_backup)">{{equipmentInfoDetails.wifi.has_4g_backup}}</span>
                  <span *ngIf="![true, false].includes(equipmentInfoDetails?.wifi?.has_4g_backup)"> - </span>
                </td>
              </tr>
              <tr>
                <td class="label" translate>company.connectivity.details.equipment.info-popup.table.tech.label</td>
                <td>
                  <div class="data">
                    <span><b translate>company.connectivity.details.equipment.info-popup.table.tech.ip</b></span>
                    <span
                      *ngIf="equipmentInfoDetails?.wifi?.technical_parameters?.ip_address_v4">{{equipmentInfoDetails.wifi.technical_parameters.ip_address_v4}}</span>
                    <span *ngIf="!equipmentInfoDetails?.wifi?.technical_parameters?.ip_address_v4"> - </span>
                  </div>
                  <div class="data">
                    <span><b translate>company.connectivity.details.equipment.info-popup.table.tech.ipv6</b></span>
                    <span
                      *ngIf="equipmentInfoDetails?.wifi?.technical_parameters?.ip_address_v6">{{equipmentInfoDetails.wifi.technical_parameters.ip_address_v6}}</span>
                    <span *ngIf="!equipmentInfoDetails?.wifi?.technical_parameters?.ip_address_v6"> - </span>
                  </div>
                  <div class="data">
                    <span><b translate>company.connectivity.details.equipment.info-popup.table.tech.ipv4</b></span>
                    <span
                      *ngIf="equipmentInfoDetails?.wifi?.technical_parameters?.ip_address_v4">{{equipmentInfoDetails.wifi.technical_parameters.ip_address_v4}}</span>
                    <span *ngIf="!equipmentInfoDetails?.wifi?.technical_parameters?.ip_address_v4"> - </span>
                  </div>
                  <div class="data">
                    <span><b translate>company.connectivity.details.equipment.info-popup.table.tech.username</b></span>
                    <span
                      *ngIf="equipmentInfoDetails?.wifi?.technical_parameters?.user_name">{{equipmentInfoDetails.wifi.technical_parameters.user_name}}</span>
                    <span *ngIf="!equipmentInfoDetails?.wifi?.technical_parameters?.user_name"> - </span>
                  </div>
                  <div class="data">
                    <span><b translate>company.connectivity.details.equipment.info-popup.table.tech.password</b></span>
                    <span
                      *ngIf="equipmentInfoDetails?.wifi?.technical_parameters?.password">{{equipmentInfoDetails.wifi.technical_parameters.password}}</span>
                    <span *ngIf="!equipmentInfoDetails?.wifi?.technical_parameters?.password"> - </span>
                  </div>
                  <div class="data">
                    <span><b translate>company.connectivity.details.equipment.info-popup.table.tech.user-vlan</b></span>
                    <span
                      *ngIf="equipmentInfoDetails?.wifi?.technical_parameters?.user_vlan">{{equipmentInfoDetails.wifi.technical_parameters.user_vlan}}</span>
                    <span *ngIf="!equipmentInfoDetails?.wifi?.technical_parameters?.user_vlan"> - </span>
                  </div>
                  <div class="data">
                    <span><b translate>company.connectivity.details.equipment.info-popup.table.tech.smtp</b></span>
                    <span
                      *ngIf="equipmentInfoDetails?.wifi?.technical_parameters?.smtp">{{equipmentInfoDetails.wifi.technical_parameters.smtp}}</span>
                    <span *ngIf="!equipmentInfoDetails?.wifi?.technical_parameters?.smtp"> - </span>
                  </div>
                  <div class="data">
                    <span><b
                        translate>company.connectivity.details.equipment.info-popup.table.tech.primary-dns</b></span>
                    <span
                      *ngIf="equipmentInfoDetails?.wifi?.technical_parameters?.primary_dns">{{equipmentInfoDetails.wifi.technical_parameters.primary_dns}}</span>
                    <span *ngIf="!equipmentInfoDetails?.wifi?.technical_parameters?.primary_dns"> - </span>
                  </div>
                  <div class="data">
                    <span><b
                        translate>company.connectivity.details.equipment.info-popup.table.tech.secondary-dns</b></span>
                    <span
                      *ngIf="equipmentInfoDetails?.wifi?.technical_parameters?.secondary_dns">{{equipmentInfoDetails.wifi.technical_parameters.secondary_dns}}</span>
                    <span *ngIf="!equipmentInfoDetails?.wifi?.technical_parameters?.secondary_dns"> - </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="label" translate>company.connectivity.details.equipment.info-popup.table.address.label</td>
                <td>
                  <div class="data">
                    <span
                      *ngIf="equipmentInfoDetails?.wifi?.address?.company_name">{{equipmentInfoDetails.wifi.address.company_name}}</span>
                    <span *ngIf="!equipmentInfoDetails?.wifi?.address?.company_name"> - </span>
                  </div>
                  <div class="data">
                    <span *ngIf="equipmentInfoDetails?.wifi?.address">
                      Via {{ equipmentInfoDetails.wifi.address.building | titlecase }} {{
                      equipmentInfoDetails.wifi.address.number | titlecase }}, {{ equipmentInfoDetails.wifi.address.city
                      | titlecase }} {{ equipmentInfoDetails.wifi.address.province | titlecase }}
                    </span>
                    <span *ngIf="!equipmentInfoDetails?.wifi?.address"> - </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="loading" class="main">
        <ngx-skeleton-loader [theme]="{'height':'916px'}"></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>